/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Route } from 'react-router';
import { NotFoundPage } from 'sarsaparilla';

import PassSelectionPage from '../src/containers/PassSelectionPage';
import PassOrderDetailsPage from '../src/containers/PassOrderDetailsPage';

import routesArray from './routesArray';

const Components = {
    PassSelectionPage,
    PassOrderDetailsPage,
};

export default function makeSwitchRoutes() {
    const routeComponents = routesArray.map((route) => {
        const Component = Components[route.componentName];

        return <Route key={route.path} path={route.path} element={<Component />} />;
    });

    routeComponents.push(<Route path="*" key="notFound" element={<NotFoundPage />} />);

    return routeComponents;
}
